<template>
    <div id="wrapper" :class="langCss">
        <!-- start header -->
        <header>
            <div class="navbar navbar-default navbar-static-top">
                <div class="container">
                    <div class="navbar-header">
                        <button type="button" class="navbar-toggle" data-toggle="collapse"
                            data-target=".navbar-collapse">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <router-link to="/" class="navbar-brand"><img src="/static/img/logo.png" alt="logo" /></router-link>
                    </div>
                    <div class="navbar-collapse collapse ">
                        <ul class="nav navbar-nav">
                            <li><router-link to="/" class="navbar-item">{{ $t('message.home') }}</router-link></li>
                            <li><router-link to="/services" class="navbar-item">{{ $t('message.serve') }}</router-link></li>
                            <!-- <li v-if="langCss != 'cn'"><a href="http://www.cflytrip.com" class="navbar-item" style="color:coral" >{{ $t('message.book') }}</a></li> -->
                            <li class="active"><router-link to="/portf" class="navbar-item">{{ $t('message.port')}}</router-link></li>
                            <!-- <li><router-link to="/aboutus" class="navbar-item">{{ $t('message.au') }}</router-link></li> -->
                            <li><router-link to="/pricing" class="navbar-item">{{ $t('message.pric') }}</router-link></li>
                            <li><router-link to="/contact" class="navbar-item">{{ $t('message.contact') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="ceswich">
                        <button style="background:none;border:none" :class="langCss === 'cn' ? 'xz' : ''"
                            @click="switchLang('cn')">{{ $t('message.switchCn') }}</button> |
                        <button style="background:none;border:none" :class="langCss === 'en' ? 'xz' : ''"
                            @click="switchLang('en')">{{ $t('message.switchEn') }}</button>
                    </div>
                </div>
            </div>
        </header>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">{{ $t('message.port') }}</h2>
                    </div>
                </div>
            </div>
        </section>
        <section id="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="about-logo">
                            <h3>{{ $t('message.tab') }}</h3>
                            <p>{{ $t('message.portCon') }}</p>
                            <p>{{ $t('message.portcon2') }}</p>
                        </div>
                        <!-- <a href="#" class="btn btn-color">Read more</a> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <!-- <ul class="portfolio-categ filter">
                            <li class="all active"><a href="#">{{ $t('message.tab') }}</a></li>
                        </ul> -->
                        <div class="clearfix">
                        </div>
                        <div class="row">
                            <section id="projects">
                                <ul id="thumbs" class="portfolio">
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 design" data-id="id-0" data-type="web">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/1.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/1.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 design" data-id="id-1" data-type="icon">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/2.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/2.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 photography" data-id="id-2" data-type="graphic">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/3.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/3.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 design" data-id="id-0" data-type="web">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/4.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/4.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 photography" data-id="id-4" data-type="web">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/5.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/5.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 photography" data-id="id-5" data-type="icon">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/6.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/6.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <li class="item-thumbs col-lg-3 design" data-id="id-0" data-type="web">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/7.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/7.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                    <!-- Item Project and Filter Name -->
                                    <li class="item-thumbs col-lg-3 design" data-id="id-0" data-type="graphic">
                                        <!-- Fancybox - Gallery Enabled - Title - Full Image -->
                                        <a class="hover-wrap fancybox" data-fancybox-group="gallery"
                                            title="" href="/static/img/works/8.jpg">
                                            <span class="overlay-img"></span>
                                            <span class="overlay-img-thumb"><i class="icon-info-blocks fa fa-code"></i></span>
                                        </a>
                                        <!-- Thumb Image and Description -->
                                        <img src="/static/img/works/8.jpg" alt="">
                                    </li>
                                    <!-- End Item Project -->
                                </ul>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="widget">
                                <address style="width:60%;float: left;">
                                    <strong>{{$t('message.addr')}}</strong><br>
                                    {{$t('message.addrcon')}}
                                </address>
                                <p style="margin-left:5%;width:30%;float: left;">
                                    <strong>{{$t('message.widgetCn')}}</strong><br>
                                    <i class="icon-phone"></i> {{$t('message.fixedTelephone')}} <br>
                                    <i class="icon-envelope-alt"></i> leo@cflytrip.com
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading"> {{$t('message.domestic')}} </h5>
                                <ul class="link-list">
                                    <li><a href="https://www.airchina.com.cn/" target="_blank">{{$t('message.flinkCon')}}</a></li>
                                    <li><a href="https://www.ceair.com/" target="_blank">{{$t('message.flinkCon2')}}</a></li>
                                    <li><a href="https://www.csair.com/" target="_blank">{{$t('message.flinkCon3')}}</a></li>
                                    <li><a href="https://www.hnair.com/" target="_blank">{{$t('message.flinkCon4')}}</a></li>
                                    <li><a href="https://www.cdal.com.cn" target="_blank">{{$t('message.flinkCon5')}}</a></li>
                                    <li><a href="https://www.loongair.cn" target="_blank">{{$t('message.flinkCon6')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.international')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.vietjet-air.com/" target="_blank">{{$t('message.flinkCon7')}}</a></li>
                                    <li><a href="https://www.koreanair.com/" target="_blank">{{$t('message.flinkCon8')}}</a></li>
                                    <li><a href="https://www.ana.co.jp/" target="_blank">{{$t('message.flinkCon9')}}</a></li>
                                    <li><a href="https://www.hkexpress.com/" target="_blank">{{$t('message.flinkCon10')}}</a></li>
                                    <li><a href="https://www.flyasiana.com/" target="_blank">{{$t('message.flinkCon11')}}</a></li>
                                    <li><a href="https://www.united.com/" target="_blank">{{$t('message.flinkCon12')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.platform')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.ctrip.com/" target="_blank">{{$t('message.flinkCon13')}}</a></li>
                                    <li><a href="https://www.qunar.com/" target="_blank">{{$t('message.flinkCon14')}}</a></li>
                                    <li><a href="https://www.ly.com/" target="_blank">{{$t('message.flinkCon15')}}</a></li>
                                    <li><a href="https://www.fliggy.com/" target="_blank">{{$t('message.flinkCon16')}}</a></li>
                                    <li><a href="https://www.meituan.com/" target="_blank">{{$t('message.flinkCon17')}}</a></li>
                                    <li><a href="https://buyer.pkfare.com/" target="_blank">{{$t('message.flinkCon18')}}</a></li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div id="sub-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="copyright">
                                    <p>
                                        <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2020020380号-1</a>
                                        <span>&copy; Copyright ©2024 晨飞旅业 All Rights Reserved. </span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6" style="position: relative;">
                              <a class="rztz" href="http://cx.cnca.cn/CertECloud/result/skipResultList?certNumber=05324I10341R0M%20%20%20&orgName=&fromIndex=true" target="_blank"><img class="ISO2007RZ" src="/static/img/rz2007.png" alt=""></a>
                                <!-- <ul class="social-network">
                                    <li>
                                        <a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
    </div>
</template>

<script>
export default {
    name: "portfo",
    data() {
        return {
            langCss: window.localStorage.getItem("lang"),
            dialogVisible: false,
            currentUrl:''
        };
    },
    methods: {
        switchLang(lang) {
            this.$i18n.locale = lang;
            //把语言保存在localStorage中
            localStorage.setItem("lang", lang);
            //切换父级class
            this.langCss = lang;
        },
        handleClose(done) {
            this.$confirm(this.$t("message.confirm")) //js内部切换
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-css button {
    width: 150px;
}

.en .vue-css button {
    color: steelblue;
}

.cn .vue-css button {
    color: #666;
}

.ja .vue-css button {
    color: seagreen;
}

.xz {
    color: #37A691
}
</style>



// WEBPACK FOOTER //
// src/views/portfolio/portf.vue